import { ButtonColors } from '@workday/canvas-kit-react/button';
import { createComponent } from '@workday/canvas-kit-react/common';
// eslint-disable-next-line no-restricted-imports
import { SegmentedControl } from '@workday/canvas-kit-react/segmented-control';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';

const getIconButtonColors = (toggled?: boolean): ButtonColors => ({
  default: {
    background: toggled ? WcpStyles.color.bg.primary.default : WcpStyles.color.bg.alt.soft,
    icon: toggled ? WcpStyles.color.icon.inverse : WcpStyles.color.icon.default,
  },
  hover: {
    background: toggled ? WcpStyles.color.bg.primary.default : WcpStyles.color.bg.alt.default,
    icon: toggled ? WcpStyles.color.icon.inverse : WcpStyles.color.icon.strong,
  },
  active: {
    background: toggled ? WcpStyles.color.bg.primary.default : WcpStyles.color.bg.alt.stronger,
    icon: toggled ? WcpStyles.color.icon.inverse : WcpStyles.color.icon.strong,
  },
  focus: {
    background: toggled ? WcpStyles.color.bg.primary.default : WcpStyles.color.bg.alt.soft,
    icon: toggled ? WcpStyles.color.icon.inverse : WcpStyles.color.icon.strong,
    border: toggled ? 'transparent' : WcpStyles.color.border.input.default,
  },
  disabled: {
    background: WcpStyles.color.bg.alt.softer,
    border: WcpStyles.color.border.input.disabled,
    icon: WcpStyles.color.icon.soft,
    opacity: '1',
  },
});

export const ThemedDeprecatedSegmentedControlButton = createComponent('button')({
  Component: (props: React.ComponentProps<typeof SegmentedControl.Button>, ref: Ref<HTMLButtonElement>, Element) => (
    <SegmentedControl.Button
      ref={ref}
      as={Element}
      colors={getIconButtonColors(props.toggled)}
      borderColor={
        props.disabled
          ? `${WcpStyles.color.border.input.disabled} !important`
          : `${WcpStyles.color.border.input.default} !important`
      }
      {...props}
    />
  ),
});

export const ThemedDeprecatedSegmentedControl = (props: React.ComponentProps<typeof SegmentedControl>) => (
  <SegmentedControl {...props} />
);
ThemedDeprecatedSegmentedControl.Button = ThemedDeprecatedSegmentedControlButton;
